import { useState } from 'react';
import PropTypes from 'prop-types';
import EmailValidation from 'Components/EmailValidation';
import Heading from 'Components/Heading';
import LoginButton from 'Components/LoginButton';
import ProgressBar from 'Components/ProgressBar';

const Home = ({
  applicationConfig,
  failureMessage,
  loading,
  routerCallback,
  strings,
  transitionTo,
  uim,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const cta1 = applicationConfig.cta1 || strings.cta1;
  const socialProviders = applicationConfig.loginProviders.filter(
    (p) => p !== 'email'
  );
  const showEmail = applicationConfig.loginProviders.includes('email');
  const autoFocus = showEmail && socialProviders.length === 0;
  const autoSubmit = !showEmail && loginProviders.length === 1;

  const handleSubmit = () => setSubmitting(true);

  const handleClick = (provider) => {
    handleSubmit();
    routerCallback(provider, false);
  };

  if (uim && autoSubmit) routerCallback(socialProviders[0], false);

  return (
    <>
      {(submitting || autoSubmit || loading) && <ProgressBar />}
      <Heading cta1={cta1} cta2={strings.cta2} />
      {showEmail && (
        <EmailValidation
          autoFocus={autoFocus}
          continueText={strings.continue}
          disabled={loading}
          emailText={strings.email}
          errorText={strings.errorMessage}
          failureMessage={failureMessage}
          onSubmit={handleSubmit}
          transitionTo={transitionTo}
          uim={uim}
          validText={strings.validEmail}
          disallowRegistration={applicationConfig.disallowRegistration}
        />
      )}
      {showEmail && socialProviders.length > 0 && (
        <div className="divider">
          <span className="divider__text">
            {socialProviders.length > 1 ? strings.orContinueWith : strings.or}
          </span>
        </div>
      )}
      <div
        className={showEmail && socialProviders.length > 1 ? 'btn__row' : ''}
      >
        {socialProviders &&
          socialProviders.map((provider) => (
            <LoginButton
              autoSubmit={autoSubmit}
              key={provider}
              disabled={autoSubmit || loading || submitting}
              onClick={() => handleClick(provider)}
              provider={provider}
              text={strings.continueWith}
              type={showEmail && socialProviders.length > 1 ? 'icon' : 'detail'}
            />
          ))}
      </div>
    </>
  );
};

Home.propTypes = {
  applicationConfig: PropTypes.object.isRequired,
  failureMessage: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  routerCallback: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

Home.defaultProps = {
  loading: false,
};

export default Home;
